/**
 * @fileoverview Agent definition for inspiration-attribute-deriver-v1.
 *
 * This agent analyzes a photo of a person and derives PersonProfileSchema
 * attributes based on the image mode (portrait, half-body, full-body).
 * Used in the Inspiration Database to populate character attributes from photos.
 *
 * @category visuals.images.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'inspiration-attribute-deriver-v1',
  kind: 'primitive',
  name: 'Inspiration Attribute Deriver',
  description: 'Analyzes a photo of a person and derives character inspiration attributes (physical appearance, body type, etc.) based on the image framing mode.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'visuals.images.analysis',
    usedBy: [
      'use-derive-inspiration-attributes.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'image-classifier-v1',
      'character-details-multimodal-generator-v3',
    ],
  },
};
